import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import ParityNotificationsService from '~/services/ParityNotificationsService';

import type { ParityNotificationBody } from '~/types/services/parityNotifications';

import { parityNotificationQueryKeys } from './parityNotificationQueryKeys';

export function useCreateParityNotification(onSuccess?: () => void) {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: ParityNotificationBody) => ParityNotificationsService.postParityNotification(body),
    onSuccess: (created) => {
      enqueueSnackbar(`Notification created — ID: ${created.id}`, { variant: 'success' });
      queryClient.invalidateQueries({ queryKey: parityNotificationQueryKeys.unsolvedParity() });
      onSuccess?.();
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error: ${error.message}`, { variant: 'error' });
    },
  });
}
